/**
 * Het projectenoverzicht op de gedeelde archiefmachinerie zetten.
 *
 * Doelgroep en dienst zijn onafhankelijke assen (zie archive-projects.blade.php), dus
 * beide worden bij elke wissel meegeschreven: het wisselen van de ene as mag de gekozen
 * waarde op de andere niet wissen.
 */

import initArchiveFilter, { setParam } from './archive-filter';
import initProjectCards from './project-cards';

export default function initProjectsFilter() {
  const filter = document.querySelector('[data-projects-filter]');

  // Onder md is de doelgroep een select en zijn de radio's verborgen; daarboven andersom.
  // Twee besturingen, maar niet twee waarheden: de select schrijft zijn keuze in de radio's,
  // zodat buildUrl() hieronder onveranderd uit diezelfde radio's kan blijven lezen.
  //
  // Deze listener hangt bewust vóór initArchiveFilter(): allebei luisteren ze gedelegeerd op
  // hetzelfde element, en die vuren in de volgorde waarin ze zijn toegevoegd. Andersom bouwt
  // de gedeelde afhandeling de URL op uit de radio's zoals ze nog stonden.
  //
  // De lege waarde matcht geen enkele radio, dus "Alle doelgroepen" laat ze allemaal uit --
  // precies de stand die buildUrl() als audience='' leest.
  if (filter) {
    filter.addEventListener('change', (event) => {
      if (!event.target.matches('.projects-filter__audience-filter')) {
        return;
      }

      filter.querySelectorAll('.projects-filter__cat-filter').forEach((radio) => {
        radio.checked = radio.value === event.target.value;
      });
    });
  }

  initArchiveFilter({
    filter: '[data-projects-filter]',
    results: '[data-projects-results]',
    option: '[data-audience-option]',
    all: '[data-audience-all]',
    controls: '.projects-filter__cat-filter, .projects-filter__subcat-filter, .projects-filter__audience-filter',
    scrollTarget: '#projects',

    buildUrl(url, filter) {
      const checked = filter.querySelector('.projects-filter__cat-filter:checked');
      const select = filter.querySelector('.projects-filter__subcat-filter');

      setParam(url, 'audience', checked ? checked.value : '');
      setParam(url, 'subcategory', select ? select.value : '');

      // ?category= is hier het terugvalpad voor oude links naar een doelgroep
      // (zie ArchiveProjects::resolveAudience). Laat je hem staan, dan springt hij
      // terug aan zodra de doelgroep op "Alles" gaat.
      url.searchParams.delete('category');
    },

    // De kaarten hangen hun eigen hovervideo aan de nodes die zojuist vervangen zijn.
    afterSwap: initProjectCards,

    describe: (count) => {
      if (count === 0) {
        return 'Geen projecten gevonden.';
      }

      return count === 1 ? '1 project gevonden.' : `${count} projecten gevonden.`;
    },

    entry: ['audience', 'category', 'subcategory', 'pag'],
  });
}
